<div class="ps-4 pe-4">
    <div mat-dialog-content class="mt-4 mb-4">
        <p>
            {{ 'auth.terms.updated_message' | translate}} <a href="javascript:void(0)" (click)="openTermOfServiceDialog()">{{ 'auth.terms.terms_of_service' | translate }}</a>, <br>
            {{ 'auth.terms.please_agree' | translate }}
        </p>
    </div>
    <div mat-dialog-actions align="left" class="mt-4 mb-4">
        <ui-button mat-dialog-close 
            label="action.agree"
            color="primary"
            variant="flat"
            (click)="agreeToTerms()"
            />
    </div>
</div>